// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EyPz2","col":"styles_col__ZmlZA"};